import React from 'react';
import { PlayIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { Reveal } from '../components/Reveal';
import { ImageReveal } from '../components/ImageReveal';
import { Button } from '../components/Button';
import { talks, speakingTopics, featuredEvents } from '../data/speaking';
import { images } from '../data/site';
const keynotes = [{
  title: 'Building where the infrastructure isn’t',
  event: 'Africa Tech Summit · Nairobi',
  length: '22 min',
  image: images.speakingStage
}, {
  title: 'The economics of opportunity',
  event: 'TEDx Lagos',
  length: '16 min',
  image: images.founderMeeting
}];
export function Speaking() {
  return <>
      <PageHeader eyebrow="Speaking" title="Conversations that move rooms." intro="Keynotes, panels and fireside conversations on company building, capital, and the ecosystems that make both possible." data-id="element-439" data-mp="3dzxhxndre863" />

      <section className="px-4 sm:px-6" data-id="element-440" data-mp="22nwo3u21ftjh">
        <div className="relative mx-auto max-w-[92rem]" data-id="element-441" data-mp="2bp589ajbndmo">
          <ImageReveal src={images.speakingStage} alt="Keynote stage at a global technology summit" className="aspect-[16/9] rounded-[2rem] border border-charcoal/[0.07]" imgClassName="brightness-[0.68]" parallax={28} data-id="element-442" data-mp="2bnlsdl1kv4lf" />
          <div className="absolute inset-0 flex items-end p-8 sm:p-14" data-id="element-443" data-mp="26or4i4or6pug">
            <Reveal data-id="element-444" data-mp="1syf8hup1s6y1">
              <blockquote className="max-w-3xl font-serif text-[1.75rem] font-light italic leading-[1.16] text-ivory sm:text-[3.25rem]" data-id="element-445" data-mp="1sxw29b8rf6zu">
                “I believe innovation should create opportunity that lasts.”
              </blockquote>
            </Reveal>
          </div>
        </div>
      </section>

      {/* Topics */}
      <section className="px-6 py-24 sm:px-10 sm:py-36" data-id="element-446" data-mp="1a0ba9vap7sb0">
        <div className="mx-auto grid max-w-[92rem] gap-14 lg:grid-cols-12" data-id="element-447" data-mp="1a0uujintmss7">
          <div className="lg:col-span-4" data-id="element-448" data-mp="1e26eb7k0kjsh">
            <Reveal data-id="element-449" data-mp="1e40w4czznvsc">
              <p className="eyebrow text-mocha" data-id="element-450" data-mp="3golffenviw2n">Signature topics</p>
              <h2 className="mt-6 font-serif text-[2.5rem] font-light leading-[1.04] text-charcoal sm:text-[3.25rem]" data-id="element-451" data-mp="3gpwjzgp587ut">
                What I speak about.
              </h2>
            </Reveal>
          </div>
          <div className="grid gap-x-12 gap-y-12 sm:grid-cols-2 lg:col-span-7 lg:col-start-6" data-id="element-452" data-mp="36wpgy2hvl3xw">
            {speakingTopics.map((t, i) => <Reveal key={t.title} delay={i * 0.08} data-id="element-453" data-mp="3il94wnanu1r" data-mpi={i}>
                <div className="border-t border-charcoal/15 pt-6" data-id="element-454" data-mp="3fz3x3nvlqmp">
                  <h3 className="font-serif text-[1.5rem] font-light leading-tight text-charcoal" data-id="element-455" data-mp="3upo3ty2ccigq">
                    {t.title}
                  </h3>
                  <p className="mt-4 text-sm leading-relaxed text-charcoal/60" data-id="element-456" data-mp="3lnokgz3ut2am">
                    {t.body}
                  </p>
                </div>
              </Reveal>)}
          </div>
        </div>
      </section>

      {/* Stages */}
      <section className="border-y border-charcoal/[0.08] bg-ivorydeep/50 px-6 py-20 sm:px-10" data-id="element-457" data-mp="2a6y9l2ohjmao">
        <div className="mx-auto max-w-[92rem]" data-id="element-458" data-mp="prs6b4ptigfh">
          <Reveal data-id="element-459" data-mp="ts2b4e1vj0sr">
            <p className="eyebrow text-charcoal/40" data-id="element-460" data-mp="trkbr8jx06gm">Stages</p>
          </Reveal>
          <div className="mt-10 grid grid-cols-2 gap-px overflow-hidden rounded-[1.5rem] border border-charcoal/[0.09] bg-charcoal/[0.09] sm:grid-cols-3 lg:grid-cols-5" data-id="element-461" data-mp="yrf65m2wfe6f">
            {featuredEvents.map((e, i) => <Reveal key={e} delay={i * 0.04} data-id="element-462" data-mp="18hhzjndxmu5a" data-mpi={i}>
                <div className="flex h-24 items-center justify-center bg-ivory px-4 text-center" data-id="element-463" data-mp="18gov4t2g4gqb">
                  <span className="font-serif text-sm tracking-[0.14em] text-charcoal/50 sm:text-base" data-id="element-464" data-mp="1de8eg7e03jp4">
                    {e.toUpperCase()}
                  </span>
                </div>
              </Reveal>)}
          </div>
        </div>
      </section>

      {/* Featured talks video */}
      <section className="px-6 py-24 sm:px-10 sm:py-36" data-id="element-465" data-mp="3jb4aap08478e">
        <div className="mx-auto max-w-[92rem]" data-id="element-466" data-mp="3o95rf4e39wh8">
          <Reveal data-id="element-467" data-mp="3o9xoykr8y4a5">
            <p className="eyebrow text-mocha" data-id="element-468" data-mp="2sxo2srrjiek0">Featured keynotes</p>
          </Reveal>
          <div className="mt-12 grid gap-12 md:grid-cols-2" data-id="element-469" data-mp="2szr0lxyxpbza">
            {keynotes.map((k, i) => <Reveal key={k.title} delay={i * 0.1} data-id="element-470" data-mp="32w3vgz67tvvm" data-mpi={i}>
                <button type="button" className="group block w-full text-left" data-id="element-471" data-mp="32usut882h48q">
                  <div className="relative aspect-video overflow-hidden rounded-[1.5rem] border border-charcoal/[0.07]" data-id="element-472" data-mp="2xwr729zp4gqx">
                    <img src={k.image} alt="" loading="lazy" className="h-full w-full object-cover brightness-[0.78] transition-transform duration-[1.6s] ease-editorial group-hover:scale-[1.05]" data-id="element-473" data-mp="2a7y9ya7c82uq" />
                    <span className="absolute inset-0 flex items-center justify-center" data-id="element-474" data-mp="2f4yjiv3ebnql">
                      <span className="inline-flex h-16 w-16 items-center justify-center rounded-full border border-ivory/50 bg-ivory/20 backdrop-blur-md transition-all duration-500 group-hover:bg-ivory/40" data-id="element-475" data-mp="1rfnl3k9iq5fm">
                        <PlayIcon className="h-5 w-5 translate-x-[1px] text-ivory" fill="currentColor" strokeWidth={0} data-id="element-476" data-mp="1y8i873h2z9c" />
                      </span>
                    </span>
                    <span className="absolute bottom-4 right-4 rounded-full bg-charcoal/60 px-3 py-1 text-xs text-ivory backdrop-blur-sm" data-id="element-477" data-mp="3t75y8nxpdhsx">
                      {k.length}
                    </span>
                  </div>
                  <h3 className="mt-6 font-serif text-[1.625rem] font-light leading-tight text-charcoal" data-id="element-478" data-mp="povxxejmqt6g">
                    {k.title}
                  </h3>
                  <p className="mt-2 text-sm text-charcoal/55" data-id="element-479" data-mp="fqopjk3epjg2">{k.event}</p>
                </button>
              </Reveal>)}
          </div>
        </div>
      </section>

      {/* Appearances */}
      <section className="px-6 pb-24 sm:px-10 sm:pb-36" data-id="element-480" data-mp="30hp7rvtn8azc">
        <div className="mx-auto max-w-[92rem]" data-id="element-481" data-mp="30f46p9165z2n">
          <Reveal data-id="element-482" data-mp="16xopscbxsjpu">
            <p className="eyebrow text-mocha" data-id="element-483" data-mp="16y6w61sbcebh">Recent appearances</p>
          </Reveal>
          <ul className="mt-10" data-id="element-484" data-mp="120ya3q41nq4y">
            {talks.map((t, i) => <Reveal key={t.title} delay={i * 0.04} as="li" data-id="element-485" data-mp="x8euknlsqkxi" data-mpi={i}>
                <div className="grid grid-cols-1 items-baseline gap-2 border-t border-charcoal/[0.1] py-6 sm:grid-cols-12 sm:gap-6" data-id="element-486" data-mp="x6u4ba6ilo5g">
                  <span className="font-serif text-lg text-mocha sm:col-span-1" data-id="element-487" data-mp="o8rv47cmnp73">
                    {t.year}
                  </span>
                  <h3 className="font-serif text-[1.375rem] font-light leading-snug text-charcoal sm:col-span-6" data-id="element-488" data-mp="j7kle2qxcfxs">
                    {t.title}
                  </h3>
                  <p className="text-sm text-charcoal/60 sm:col-span-3" data-id="element-489" data-mp="9bhnxa70p5h6">
                    {t.event} · {t.location}
                  </p>
                  <p className="text-xs uppercase tracking-[0.14em] text-charcoal/40 sm:col-span-2 sm:text-right" data-id="element-490" data-mp="28nk3i9citfpk">
                    {t.format}
                  </p>
                </div>
              </Reveal>)}
          </ul>
        </div>
      </section>

      <section className="border-t border-charcoal/[0.08] px-6 py-28 text-center sm:px-10 sm:py-40" data-id="element-491" data-mp="2g6tdo4supifo">
        <Reveal data-id="element-492" data-mp="2kzco4sw8rxg9">
          <h2 className="mx-auto max-w-3xl font-serif text-[2.5rem] font-light leading-[1.04] text-charcoal sm:text-[3.75rem]" data-id="element-493" data-mp="2kyuv054vlzck">
            Bring Amoye to your stage.
          </h2>
          <p className="mx-auto mt-8 max-w-lg text-base leading-relaxed text-charcoal/65" data-id="element-494" data-mp="1t86wl0ul782l">
            Available for keynotes, fireside conversations, panels and closed
            executive sessions worldwide.
          </p>
          <div className="mt-12" data-id="element-495" data-mp="2268uh7j0xkln">
            <Button to="/contact" data-id="element-496" data-mp="276wtoghep7qy">Book Amoye to speak</Button>
          </div>
        </Reveal>
      </section>
    </>;
}